<template>
  <nav class="pages-nav">
    <button
      class="pages-nav__button"
      :disabled="offset <= 0"
      type="button"
      @click="loadPage(currentPage - 1)"
    >
      ←
    </button>
    <button
      v-for="page in pages"
      :key="`page-${page}`"
      class="pages-nav__page"
      :class="{ 'is-active': page === currentPage }"
      type="button"
      @click="loadPage(page)"
    >
      {{ page }}
    </button>
    <button
      class="pages-nav__button"
      :disabled="currentPage >= pages"
      type="button"
      @click="loadPage(currentPage + 1)"
    >
      →
    </button>
  </nav>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(defineProps<{
  limit?: number;
  offset?: number;
  count?: number;
}>(), {
  limit: 50,
  offset: 0,
  count: 0
});

const emit = defineEmits<{
  (e: "load", data: { offset: number }): void;
}>();

const pages = computed(() => {
  return Math.ceil(props.count / props.limit);
});
const currentPage = computed(() => {
  return props.offset / props.limit + 1;
});

function loadPage(page) {
  emit("load", {
    offset: (page - 1) * props.limit
  });
}
</script>

<style lang="scss">
.pages-nav {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  flex-shrink: 0;

  &__page {
    background: none;
    border: 1px solid transparent;
    cursor: pointer;
    align-self: center;
    padding: 0.25rem 0.5rem;
    border-radius: 5px;
    min-width: 2em;
    transition: background-color 250ms, border 250ms, color 250ms;

    &:hover {
      color: var(--color-action);
    }

    &.is-active {
      font-weight: 600;
      border: 1px solid var(--color-action);
      background-color: var(--color-action);
      color: var(--color-action-contrast);
      box-shadow: 0 1px 3px var(--color-shadow-1);
    }
  }

  &__button {
    cursor: pointer;
    background: var(--color-background-close);
    border: 1px solid var(--color-text-light);
    border-radius: 5px;
    color: var(--color-text);
    align-self: center;
    padding: 0.25rem 0.5rem;
    transition: background-color 250ms, border 250ms, color 250ms;

    &:hover {
      background-color: var(--color-background-close-hover);
    }

    &:disabled {
      color: var(--color-text-lighter);
      border-color: currentColor;
      background: transparent;
      cursor: auto;
    }
  }
}
</style>
